















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AppMenuNotificationContent extends Vue {
    @Prop({ required: false, default: false }) link!: string;
    @Prop({ required: false, default: null }) read!: string | null;

    counter: number | any = null;

    handleMouseenter() {
        if (this.read) {
            return;
        }

        this.counter = setTimeout(() => {
            if (!this.counter) {
                return;
            }

            this.nullCounter();
            this.$emit('read:single');
        }, 500);
    }

    handleMouseleave() {
        if (!this.counter) {
            return;
        }

        this.nullCounter();
    }

    nullCounter() {
        this.counter = null;
    }
}
